import { frontendURL } from '../../../helper/URLHelper';
import SupportTicketsIndex from './pages/SupportTicketsIndex.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/tickets'),
    alias: [
      frontendURL('accounts/:accountId/suporte/tickets'),
      frontendURL('accounts/:accountId/chamados'),
      frontendURL('accounts/:accountId/support-tickets'),
    ],
    name: 'support_tickets_portal_index',
    component: SupportTicketsIndex,
    meta: { permissions: ['administrator', 'agent', 'custom_role'] },
  },
];
